import { render, staticRenderFns } from "./formResponse.vue?vue&type=template&id=96fc0e36&scoped=true"
import script from "./formResponse.vue?vue&type=script&lang=js"
export * from "./formResponse.vue?vue&type=script&lang=js"
import style0 from "./formResponse.vue?vue&type=style&index=0&id=96fc0e36&prod&scoped=true&lang=css"
import style1 from "./formResponse.vue?vue&type=style&index=1&id=96fc0e36&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fc0e36",
  null
  
)

export default component.exports